import { BasketService } from 'src/app/services/basket.service';
import { ToolsService } from './../../services/tools.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SpaService } from 'src/app/services/spa.service';
import { Store } from 'src/app/store';
import { TrybeService } from 'src/app/services/trybe.service';

@Component({
    selector: 'app-treatments',
    templateUrl: './treatments.component.html',
    styleUrls: ['./treatments.component.css']
})
export class TreatmentsComponent implements OnInit {

    trbCategories = [];
    offerings = [];
    basket$ = this.store.select<any>('basket');


    serviceCategories = [];
    serviceCategory = [];
    staff = [];
    basket = {
        total: 0,
        items: []
    };
    categorySelected = '';

    // step = 'complete';
    step = 'treatments';
    item;

    dates = [];
    times = [];
    itemIdx = -1;
    startEpoch;
    endEpoch;

    constructor(
        private spaService: SpaService,
        private router: Router,
        private route: ActivatedRoute,
        private toolsService: ToolsService,
        private store: Store,
        private basketService: BasketService,
        private trybeService: TrybeService,
    ) { }

    ngOnInit(): void {
        this.itemIdx = this.route.snapshot.params.idx;

        const basket = this.store.selectForLocal('basket');
        this.item = basket.items[this.itemIdx];

        this.startEpoch = this.item.availabilitySearch.checkInDay;
        this.endEpoch = this.startEpoch + this.item.availabilitySearch.nights;

        this.getServiceCategories();
        this.getStaff();

        this.getTrbCategories()
    }

    getTrbCategories() {
        this.trybeService.getCategories().subscribe(data => {
            this.trbCategories = data.data.data;
            this.getTrbOfferings(this.trbCategories[0].id)
        })
    }


    getTrbOfferings(categoryId) {
        this.categorySelected = categoryId;
        this.trybeService.getOfferings(categoryId).subscribe(data => {
            this.offerings = data.data.data;
        })
    }



    viewOffering(offering) {
        this.router.navigate(['bookings/create', 'spa', this.itemIdx, 'treatment', offering.type, offering.id])
    }


    categorySelectedChange() {
        this.getTrbOfferings(this.categorySelected)
        for (let i = 0; i < this.serviceCategories.length; i++) {

            if (this.categorySelected === this.serviceCategories[i].categoryId) {
                this.getServiceCategory(this.serviceCategories[i].categoryId)
            }
        }
    }
    buildDates() {
        const dates = [];

        // if (this.route.snapshot.params.startDate) {
        //     startDate = this.route.snapshot.params.startDate;
        //     startEpoch = this.toolsService.dateToEpochDay(startDate);
        // };
        // if (this.route.snapshot.params.endDate) {
        //     endDate = this.route.snapshot.params.endDate
        //     endEpoch = this.toolsService.dateToEpochDay(endDate);
        // };

        for (let i = this.startEpoch; i <= this.endEpoch; i++) {
            dates.push({
                date: this.toolsService.dateFromEpochDay(i),
                epoch: i,
                selected: false,
                times: []
            })
        }

        return dates;
    }

    selectDate(cat, dates, idx) {
        for (let i = 0; i < dates.length; i++) {
            dates[i].selected = false;
            if (i === idx) {
                dates[i].selected = true;
            }
        }


        if (cat) {
            for (let i = 0; i < dates.length; i++) {
                if (i === idx) {
                    cat.dateSelected = dates[i];
                    this.spaService.freeAppointments(cat).subscribe(data => {
                        cat.times = data.data.data;
                    })

                }
            }
        }
    }

    selectTime(cat, ti) {

        cat.startTime = cat.times[ti].startTime;
        cat.serviceSchedule = cat.times[ti].clientSchedules[0].serviceSchedules[0];
    }

    freeAppointments(cat) {
        this.spaService.freeAppointments(cat).subscribe(data => {
            return data.data;
        })

    }


    getServiceCategories() {
        this.spaService.serviceCategories().subscribe(data => {
            this.serviceCategories = data.data;
            this.getServiceCategory(this.serviceCategories[0].categoryId)
            this.categorySelected = this.serviceCategories[0].categoryId;
        })
    }

    getServiceCategory(id) {
        this.spaService.serviceCategory(id).subscribe(data => {
            this.serviceCategory = data.data;
            for (let i = 0; i < this.serviceCategory.length; i++) {
                this.serviceCategory[i].dates = this.buildDates();
            }
        })
    }

    getStaff() {
        this.spaService.staff().subscribe(data => {
            this.staff = data.data;
        })

    }

    addToBasket(cat) {
        let priceToAdd = cat.price;
        if (cat.categoryId === 'EKwbAIIBAndj3YqcvD_agQ') {
            priceToAdd = +(+cat.price * 2)
        }
        // const basket = this.store.selectForLocal('basket');

        // if (!basket.items[this.itemIdx].treatments) {
        //     basket.items[this.itemIdx].treatments = [];
        // }
        // basket.items[this.itemIdx].treatments.push(JSON.parse(JSON.stringify(cat)));

        this.basketService.addTreatment(JSON.parse(JSON.stringify(cat)), this.itemIdx);
        cat.dateSelected = undefined;
        cat.startTime = undefined;

        this.router.navigate(['/', 'checkout'])
    }

    removeFromBasket(cat) {

        let priceToAdd = cat.price;
        if (cat.categoryId === 'EKwbAIIBAndj3YqcvD_agQ') {
            priceToAdd = +(+cat.price * 2)
        }

        this.basketService.removeTreatment(JSON.parse(JSON.stringify(cat)), this.itemIdx)
    }

    viewBasket() {
        this.step = 'basket';
    }
    viewTreatments() {
        this.step = 'treatments';
    }
    setStep(e) {
        this.step = e;
    }

    back(e) {
        this.router.navigate(['checkout', 'addons', this.itemIdx])
    }

    continue(e) {
        const basket = this.store.selectForLocal('basket');
        const item = basket.items[this.itemIdx];

        if (item.room.hotelId === 'HOTEL001' || item.room.hotelId === 'HOTEL002' || item.room.hotelId === 'HOTEL005') {
            this.router.navigate(['/bookings/create/opentable'])
        } else {
            this.router.navigate(['/bookings/create/payment'])

        }


        // this.router.navigate(['/bookings/create/opentable'])
    }

}
